"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shipmentFixtureGenerators = void 0;
const utils_ts_1 = require("@mothership/utils-ts");
const models_1 = require("../models");
const appointment_1 = require("../models/appointment");
const document_1 = require("../models/document");
const etaStatus_1 = require("../models/etaStatus");
const freight_1 = require("../models/freight");
const shipment_1 = require("../models/shipment");
const shipmentMetadata_1 = require("../models/shipmentMetadata");
const waypoint_1 = require("../models/waypoint");
const appointment = {
    createdAt: 0,
    email: 'fun_email@gmail.com',
    endTime: 1619892000000,
    id: 'document-id',
    phone: '+15705550100',
    startTime: 1619888400000,
    status: appointment_1.AppointmentStatus.Submitted,
    timeZone: 'America/Los_Angeles',
    updatedAt: 0,
};
const baseWaypointPartial = {
    accessorialAppointment: false,
    accessorialCfs: false,
    accessorialCrossDock: false,
    accessorialHomeDelivery: false,
    accessorialInside: false,
    accessorialLiftgate: false,
    accessorialLimitedAccess: false,
    accessorialLocalInsideDelivery: false,
    accessorialResidential: false,
    accessorialTradeShow: false,
    arrivedAt: null,
    completedAt: null,
    dockNumber: null,
    internalNotes: null,
    internalNotesByline: null,
    overrideEta: null,
    shipperNotesByline: null,
    streetAddress2: null,
    suggestedArrivalAt: null,
};
const pickupWaypoint = {
    ...baseWaypointPartial,
    carrierCollectedEmail: 'foo',
    city: 'Los Angeles',
    closeTime: '20:00:00',
    contactEmail: '',
    contactPhoneNumber: '+18004444444',
    country: 'US',
    createdAt: 0,
    id: 'pickup-waypoint-id',
    latitude: 34.0195628,
    locationName: 'pickup-location-name',
    longitude: -118.2379678,
    neighborhood: 'Downtown Los Angeles',
    openTime: '06:00:00',
    placeId: '',
    readyTime: '06:00:00',
    serviceDate: '2021-03-01',
    serviceWindowEndAt: 1611172836000,
    serviceWindowStartAt: 1611151236000,
    shipperNotes: 'delivery reference number: 7930009571',
    shipperReferenceNumber: '',
    state: 'CA',
    streetAddress1: '1955 East Washington Boulevard',
    timeZone: 'America/Los_Angeles',
    type: waypoint_1.WaypointType.Pickup,
    updatedAt: 0,
    zipCode: '90021',
    zoneId: 'losAngeles',
};
const deliveryWaypoint = {
    ...baseWaypointPartial,
    carrierCollectedEmail: 'foo',
    city: 'Fontana',
    closeTime: '16:00:00',
    contactEmail: '',
    contactPhoneNumber: '+18004444444',
    country: 'US',
    createdAt: 0,
    id: 'delivery-waypoint-id',
    latitude: 34.058046,
    locationName: 'delivery-location-name',
    longitude: -117.476774,
    neighborhood: 'neighborhood',
    openTime: '08:00:00',
    placeId: 'ChIJzT7WrUlLw4ARI-l6ItjyIZg',
    readyTime: null,
    serviceDate: '2021-03-01',
    serviceWindowEndAt: 1611201636000,
    serviceWindowStartAt: 1611187236000,
    shipperNotes: 'delivery reference number: 7930009571',
    shipperReferenceNumber: '',
    state: 'CA',
    streetAddress1: '10750 Hemlock Avenue',
    timeZone: 'America/Los_Angeles',
    type: waypoint_1.WaypointType.Delivery,
    updatedAt: 0,
    zipCode: '92337',
    zoneId: 'losAngeles',
};
const document = {
    createdAt: 0,
    description: 'description',
    documentFirebaseKey: 'other-document-firebase-key',
    id: 'document-id',
    tags: null,
    type: document_1.DocumentType.Other,
    updatedAt: 0,
    uploadedBy: 'uploaded-by',
    url: 'url',
    versionId: null,
    versionTime: null,
};
const etaStatus = {
    createdAt: 0,
    eligibleForAutoDispatch: false,
    etaUpdatedAt: null,
    etaWindowEndTime: null,
    etaWindowStartTime: null,
    id: 'eta-status-id',
    riskStatus: etaStatus_1.ShipmentRiskStatus.OnSchedule,
    riskStatusReasons: null,
    stopsRemainingBeforeDelivery: 0,
    updatedAt: 0,
    wasAllocatedAndDropped: null,
};
const metadata = {
    createdAt: 0,
    generateDeliveryReceipt: null,
    id: 'shipment-metadata-id',
    pickupRequestGeneratedBy: null,
    purchaseSource: shipmentMetadata_1.ShipmentPurchaseSource.SingleShipment,
    requiresBackgroundCheckedCarrier: false,
    requiresDeliveryQuestions: false,
    requiresDeliveryReceipt: true,
    rolloverReason: null,
    routeDurationMinutes: 11.51,
    routeKeys: {
        ['route-key']: true,
    },
    shipperOrganizationName: 'Mothership',
    skipTransactionalEmails: true,
    tags: {
        claim: true,
        damage: false,
    },
    transitDays: 1,
    transitDaysAdditional: null,
    updatedAt: 0,
};
const freight = {
    alcohol: false,
    cargoFirebaseKey: 'cargo-key',
    class: 400,
    createdAt: 0,
    description: 'description',
    hazmat: false,
    hazmatEmergencyContactFirstName: null,
    hazmatEmergencyContactLastName: null,
    hazmatEmergencyContactPhoneNumber: null,
    hazmatHazardClass: null,
    hazmatPackageCount: null,
    hazmatPackageType: null,
    hazmatPackingGroup: null,
    hazmatProperShippingName: null,
    hazmatUnUaId: null,
    height: 60,
    id: 'freight-id',
    length: 40,
    quantity: 1,
    tobacco: false,
    type: freight_1.FreightType.Pallet,
    updatedAt: 0,
    weight: 65,
    width: 48,
};
const inNetworkCarrierInfo = {
    carrierId: 'organization-key',
    createdAt: 0,
    dispatchId: 'dispatch-key',
    driverId: 'user-key',
    id: 'in-network-carrier-info-id',
    proNumber: 'pro-number',
    updatedAt: 0,
};
const shipment = {
    autoDispatchEligible: false,
    cancellation: null,
    completedAt: null,
    createdAt: 0,
    customerOrganizationFirebaseKey: 'organization-key',
    customerUserFirebaseKey: 'user-key',
    documents: [document],
    equipment: null,
    etaStatus,
    exceptions: [],
    freight: [freight],
    id: 'shipment-id',
    inNetworkCarrierInfo,
    laneId: null,
    loadBoardPostId: null,
    metadata,
    miles: 47.44,
    offNetworkCarrierInfo: null,
    quoteFirebaseKey: 'quote-key',
    referenceNumber: 'reference-number',
    serviceLevel: shipment_1.ShipmentServiceLevel.Standard,
    serviceType: shipment_1.ShipmentServiceType.NextDay,
    shipmentFirebaseKey: 'shipment-key',
    specialty: null,
    status: shipment_1.ShipmentStatus.DriverAllocated,
    updatedAt: 0,
    waypoints: [pickupWaypoint, deliveryWaypoint],
};
const waypointServiceWindowChangeReasonDto = {
    code: 'test-code',
    createdAt: 0,
    customerDescription: 'test-customer-description',
    id: 'waypint-service-window-change-reason-id',
    isEnabled: true,
    partyAtFault: models_1.WaypointServiceWindowChangePartyAtFault.Carrier,
    shipmentNetwork: shipment_1.ShipmentType.Direct,
    title: 'test-title',
    updatedAt: null,
};
exports.shipmentFixtureGenerators = {
    appointment: utils_ts_1.fixtureUtils.fixtureCreatorFactory(appointment),
    document: utils_ts_1.fixtureUtils.fixtureCreatorFactory(document),
    etaStatus: utils_ts_1.fixtureUtils.fixtureCreatorFactory(etaStatus),
    freight: utils_ts_1.fixtureUtils.fixtureCreatorFactory(freight),
    inNetworkCarrierInfo: utils_ts_1.fixtureUtils.fixtureCreatorFactory(inNetworkCarrierInfo),
    shipment: utils_ts_1.fixtureUtils.fixtureCreatorFactory(shipment),
    shipmentMetadata: utils_ts_1.fixtureUtils.fixtureCreatorFactory(metadata),
    waypoint: utils_ts_1.fixtureUtils.fixtureCreatorFactory(pickupWaypoint),
    waypointServiceWindowChangeReason: utils_ts_1.fixtureUtils.fixtureCreatorFactory(waypointServiceWindowChangeReasonDto),
};
//# sourceMappingURL=shipment.js.map